import React, { useEffect, useRef, useState } from 'react'
import { FiAlertTriangle, FiSave, FiSlash } from 'react-icons/fi';
import { InputValidators } from '../../../../utils/InputValidators';
import Swal from 'sweetalert2';
import { useDispatch, useSelector } from 'react-redux';
import { useForm } from 'react-hook-form';
import { Uploader } from '../../../shared/uploader/Uploader';
import { newBilling, updateBillingWithFile, updateBillingWithoutFile } from '../../../store/Thunk';


export const M_NewBillings = ({ onClose, closeOnEscape = true, closeOnBackdrop = true, selectedItem }) => {

    // ============ [ GESTION DE MODAL ] ============ //
    const [isVisible, setIsVisible] = useState(false);
    const dialogRef = useRef(null);

    useEffect(() => {
        setTimeout(() => setIsVisible(true), 10);
    }, []);

    // Cerrar con Escape si está permitido
    useEffect(() => {
        if (!closeOnEscape) return;

        const handleKeyDown = (e) => {
            if (e.key === "Escape") handleClose();
        };

        window.addEventListener("keydown", handleKeyDown);
        return () => window.removeEventListener("keydown", handleKeyDown);
    }, [closeOnEscape]);

    // Cerrar con clic fuera si está permitido
    const handleBackdropClick = (e) => {
        if (!closeOnBackdrop) return;
        if (dialogRef.current && !dialogRef.current.contains(e.target)) {
            handleClose();
        }
    };

    // Animación al cerrar
    const handleClose = () => {
        setIsVisible(false);
        setTimeout(onClose, 250); // espera la animación
    };

    //========================================================================================================

    const dispatch = useDispatch();
    const { register, handleSubmit, reset, setValue, watch, formState: { errors } } = useForm();
    const descripcionCount = watch("descriptionDevice") || "";
    const { idCustomer, billings } = useSelector(state => state.customerDetail);
    const { id_emp } = useSelector(state => state.usuario);

    // let id_emp = 9;


    // load de selected ITEM
    useEffect(() => {
        if (selectedItem) {
            setValue("rfc", selectedItem.RFC);
            setValue("numberPhone", selectedItem.TELEFONO);
            setValue("razonSocial", selectedItem.RAZON_SOCIAL);
            setValue("sociedad", selectedItem.SOCIEDAD_MERCANTIL);
            setValue("regimen", selectedItem.REGIMEN_FISCAL);
            setValue("email", selectedItem.CORREO);
            setValue("direccion", selectedItem.DIRECCION);
            setValue("cp", selectedItem.COD_POSTAL);
        } else {
            reset();
        }
    }, [selectedItem, setValue, reset]);

    // Uplaoder
    const [tempKey] = useState(() =>
        Math.random().toString(36).slice(2, 12)
    );

    const [saving, setSaving] = useState(false);
    const [uploadedCount, setUploadedCount] = useState(0);
    const uploaderRef = useRef(null);

    // =============
    const save = async (data) => {

        if (saving) return;
        if (!uploaderRef.current) return;

        setSaving(true);

        try {

            const confirm = await Swal.fire({
                title: 'Atención',
                text: selectedItem
                    ? "Está por actualizar este dato de facturación ¿Desea continuar?"
                    : "Está por registrar un nuevo dato de facturación ¿Desea continuar?",
                icon: 'question',
                customClass: {
                    confirmButton: 'btn btn-primary me-2',
                    cancelButton: 'btn btn-secondary'
                },
                showCancelButton: true,
                confirmButtonText: 'Sí, continuar',
                cancelButtonText: 'No, cancelar',
                buttonsStyling: false
            });

            if (!confirm.isConfirmed) return;

            const hasFiles = uploaderRef.current.hasPending();

            let uploadResult = { ok: true, successCount: 0 };

            /* ==========================
               SUBIDA DE ARCHIVOS
            ========================== */

            if (!selectedItem) {
                // NUEVO registro → archivo obligatorio

                uploadResult = await uploaderRef.current.uploadAll();

                if (!uploadResult.ok) {
                    Swal.fire({
                        icon: "error",
                        title: "Error al subir archivo"
                    });
                    return;
                }

                if (uploadResult.successCount === 0) {
                    Swal.fire({
                        icon: "warning",
                        title: "Archivo requerido",
                        text: "Debe subir el CSF."
                    });
                    return;
                }
            }

            else if (selectedItem && hasFiles) {
                // EDICIÓN con archivo nuevo

                uploadResult = await uploaderRef.current.uploadAll();

                if (!uploadResult.ok) {
                    Swal.fire({
                        icon: "error",
                        title: "Error al subir archivo"
                    });
                    return;
                }
            }

            /* ==========================
               GUARDADO EN BACKEND
            ========================== */

            if (selectedItem) {

                if (hasFiles) {

                    await dispatch(updateBillingWithFile(
                        data,
                        selectedItem.ID,
                        id_emp,
                        idCustomer,
                        tempKey,
                        selectedItem.CSF
                    ));

                } else {

                    await dispatch(updateBillingWithoutFile(
                        data,
                        selectedItem.ID,
                        id_emp,
                        idCustomer
                    ));

                }

            } else {

                await dispatch(newBilling(
                    data,
                    id_emp,
                    idCustomer,
                    tempKey
                ));

            }

            /* ==========================
               SUCCESS
            ========================== */

            await Swal.fire({
                icon: "success",
                title: selectedItem
                    ? "Registro actualizado correctamente"
                    : "Registro guardado correctamente",
                customClass: {
                    confirmButton: 'btn btn-primary'
                },
                confirmButtonText: 'Entendido',
                buttonsStyling: false
            });

            reset();
            onClose();

        } catch (error) {

            console.error(error);

            Swal.fire({
                icon: "error",
                title: "Error inesperado",
                text: "Ocurrió un problema al guardar."
            });

        } finally {
            setSaving(false);
        }
    };

    return (
        <div className={`modal d-block custom-backdrop ${isVisible ? "show" : ""}`} onClick={handleBackdropClick}>
            <div ref={dialogRef} className={`modal-dialog custom-modal-animate ${isVisible ? "show" : ""}`}>
                <div className="modal-content" style={{ backgroundColor: "#ffffff" }}>
                    <div className="modal-header">
                        <h5 className="modal-title fw-bold">
                            {selectedItem ? `Edición Dato de facturacion: ${selectedItem.RAZON_SOCIAL}` : "Nuevo dato de facturacion"}
                        </h5>
                        <button type="button" className="btn-close" onClick={() => { reset(); onClose(); }}></button>
                    </div>
                    <form onSubmit={handleSubmit(save)}>
                        <div className="modal-body container">
                            <div className='row'>
                                <div className="col-6 mb-3">
                                    <label className="form-label"><span className="text-danger fw-bold">*</span>RFC:</label>
                                    <input type="text" className={`form-control ${errors.rfc ? 'is-invalid' : ''}`} autoComplete='off'
                                        {...register("rfc", { required: 'RFC es requerido', minLength: { value: 13, message: 'Debe tener mínimo 13 caracteres' } })}
                                        onKeyDown={InputValidators.validateAlphanumeric} />
                                    {errors.rfc && (
                                        <div className='text-danger fw-bold mt-1'>
                                            <FiAlertTriangle size="20" /> <small>{errors.rfc.message}</small>
                                        </div>
                                    )}
                                </div>

                                <div className="col-6 mb-2">
                                    <label className="form-label"><span className="text-danger fw-bold">*</span>Telefono:</label>
                                    <input type="text" className={`form-control ${errors.numberPhone ? 'is-invalid' : ''}`} autoComplete='off' {...register("numberPhone", { required: 'RFC es requerido' })} onKeyDown={InputValidators.validateOnlyNumbers} />
                                    {errors.numberPhone && (
                                        <div className='text-danger fw-bold mt-1'>
                                            <FiAlertTriangle size="20" /> <small>{errors.numberPhone.message}</small>
                                        </div>
                                    )}
                                </div>
                            </div>

                            <div className='row'>
                                <div className="col-12 mb-2">
                                    <label className="form-label"><span className="text-danger fw-bold">*</span>Razon Social:</label>
                                    <input type="text" className={`form-control ${errors.razonSocial ? 'is-invalid' : ''}`} autoComplete='off'
                                        {...register("razonSocial", { required: 'Razon Social es requerido', minLength: { value: 5, message: 'Debe tener mínimo 5 caracteres' } })}
                                        onKeyDown={InputValidators.validateAlphanumeric} />
                                    {errors.razonSocial && (
                                        <div className='text-danger fw-bold mt-1'>
                                            <FiAlertTriangle size="20" /> <small>{errors.razonSocial.message}</small>
                                        </div>
                                    )}
                                </div>
                                <div className="col-12 mb-3">
                                    <label className="form-label"><span className="text-danger fw-bold">*</span> Sociedad:</label>
                                    <input type="text" className={`form-control ${errors.sociedad ? 'is-invalid' : ''}`} autoComplete='off'
                                        {...register("sociedad", { required: 'Sociedad Mercantil es requerido' })} onKeyDown={InputValidators.validateAlphanumeric} />
                                    {
                                        errors.sociedad &&
                                        <div className='text-left-5 mt-2'>
                                            <FiAlertTriangle size="20" color="#dc3545" />
                                            <span className='text-left-10 fw-bold text-danger'><small>{errors.sociedad.message}</small></span>
                                        </div>
                                    }
                                </div>

                                <div className="col-12 mb-3">
                                    <label className="form-label"><span className="text-danger fw-bold">*</span> Regimen Fiscal:</label>
                                    <input type="text" className={`form-control ${errors.regimen ? 'is-invalid' : ''}`} autoComplete='off'
                                        {...register("regimen", { required: 'Regimen es requerido' })} onKeyDown={InputValidators.validateAlphanumeric} />
                                    {
                                        errors.regimen &&
                                        <div className='text-left-5 mt-2'>
                                            <FiAlertTriangle size="20" color="#dc3545" />
                                            <span className='text-left-10 fw-bold text-danger'><small>{errors.regimen.message}</small></span>
                                        </div>
                                    }
                                </div>

                                <div className="col-12 mb-2">
                                    <label className="form-label"><span className="text-danger fw-bold">*</span>E-mail:</label>
                                    <input type="email" className={`form-control ${errors.email ? 'is-invalid' : ''}`} autoComplete='off'
                                        {...register("email", { required: 'Correo electronico' })} onKeyDown={InputValidators.validateEmailKeyDown} onBlur={(e) => InputValidators.validateEmailOnBlur_ReactHook(e, 'email', setValue)
                                        } />
                                    {errors.email && (
                                        <div className='text-danger fw-bold mt-1'>
                                            <FiAlertTriangle size="20" /> <small>{errors.email.message}</small>
                                        </div>
                                    )}
                                </div>
                            </div>

                            <div className='row'>
                                <div className="col-12 col-sm-12 col-md-8 col-lg-8 col-xl-8 col-xxl-8">
                                    <label className="form-label "><span className="text-danger fw-bold">*</span> Dirección:</label>
                                    <textarea className={`form-control ${errors.direccion ? 'is-invalid' : ''}`} rows="4" autoComplete='off' {...register("direccion", { required: 'Direccion es requerido.' })}></textarea>
                                    {
                                        errors.direccion &&
                                        <div className='text-left-5 mt-2'>
                                            <FiAlertTriangle size="18" color="#dc3545" />
                                            <span className='text-left-10 fw-bold text-danger'><small>{errors.direccion.message}</small></span>
                                        </div>
                                    }
                                </div>

                                <div className="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 col-xxl-4">
                                    <div className="mb-3">
                                        <label className="form-label"> <span className="text-danger fw-bold">*</span>Cod. Postal:</label>
                                        <input type="text" className={`form-control ${errors.cp ? 'is-invalid' : ''}`} aria-label="First name" autoComplete='off' onKeyDown={InputValidators.validateOnlyNumbers} {...register("cp", { required: 'CP es requerido.' })} />
                                        {
                                            errors.cp &&
                                            <div className='text-left-5 mt-2'>
                                                <FiAlertTriangle size="18" color="#dc3545" />
                                                <span className='text-left-10 fw-bold text-danger'><small>{errors.cp.message}</small></span>
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>

                            <div className='row'>
                                <Uploader
                                    ref={uploaderRef}
                                    entityType="BILLINGS_REGISTER"
                                    entityId={selectedItem?.ID || null}
                                    tempKey={tempKey}
                                    userRegister={id_emp}
                                    oldFile={selectedItem?.CSF || null}
                                    onUploadStateChange={setUploadedCount}
                                />
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-outline-danger" onClick={() => { reset(); onClose(); }}>
                                <FiSlash size={16} /> Cancelar
                            </button>
                            <button type="submit" className="btn btn-outline-primary">
                                <FiSave size={16} /> Guardar
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}
